export default "__VITE_ASSET__a63b2a05__"